import React from 'react';

export const facebookIcon = ({ ariaLabel = 'Facebook' }) => {
  return (
   <svg width="7" height="14" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.06802 3.2961C4.06802 3.43805 4.06802 3.90072 4.06802 4.55802H6.32794L6.08291 6.57259H4.06802C4.06802 9.67944 4.06802 13.8428 4.06802 13.8428H1.39357C1.39357 13.8428 1.39357 9.73454 1.39357 6.57259H0V4.55802H1.39357C1.39357 3.75909 1.39357 3.191 1.39357 3.03282C1.39357 2.27919 1.33679 1.9216 1.65702 1.33761C1.9774 0.753637 2.88111 -0.0182542 4.44416 0.000329269C6.00758 0.01959 6.66659 0.169991 6.66659 0.169991L6.32794 2.31703C6.32794 2.31703 5.32961 2.05342 4.83958 2.14737C4.35021 2.24134 4.06802 2.5428 4.06802 3.2961Z" fill="white"/>
</svg>

  );
};
